import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGalaxy: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGalaxy"><Path d="M1.25 10.8529C3.9375 3.16632 18.45 4.34875 18.45 10.6535C18.45 14.2283 11.8749 14.9594 10.6001 13.124C9.65566 11.7642 14.3096 11.881 13.3999 10.5712C12.1251 8.73584 5.55 9.46683 5.55 13.0416C5.55 19.6389 21.1375 20.9049 22.75 13.2181" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGalaxy;
